<template>
  <div id="calendarList" class="pb-[16px] px-5 md:px-6 lg:px-8 pt-[75px] overflow-x-hidden">
    <div v-for="(month, index) in monthEvents" :key="index">
      <div
        class="text-[1.25rem] md:text-[1.5rem] lg:text-[1.75rem] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.75rem] font-black mt-[20px] mb-[12px] tracking-[-0.03em]"
        :class="{ 'pt-[60px]': index === 0 }"
      >
        {{ month.name }}
      </div>
      <!-- Training Announcement Card for this month -->
      <TrainingAnnouncements
        v-if="getTrainingAnnouncementForMonth(month.month, month.year)"
        :announcement="getTrainingAnnouncementForMonth(month.month, month.year)"
        class="mb-[12px]"
      />
      <EventItem
        v-for="event in month.event"
        :key="event.id || event.title"
        class="mb-[12px] eventItem"
        :title="event.title"
        :description="event.description"
        :event-time-location="event.eventTimeLocation"
        :startDate="event.startDate"
        :endDate="event.endDate"
        :tags="event.tags"
        :link="event.link"
        :isExternal="event.isExternal"
        :buttonText="event.buttonText"
        :dataEventTracking="event.dataEventTracking"
        :month="month.month"
        :year="month.year"
      />
      <Placeholder
        v-if="month.event.length === 0"
        class="eventItem bg-ivory"
        :month="month.month"
        :year="month.year"
      />
    </div>
  </div>
</template>

<script>
import EventItem from '@/components/Calendar/Events/EventItem.vue';
import Placeholder from '@/components/common/Placeholder.vue';
import TrainingAnnouncements from '@/components/Calendar/TrainingAnnouncements.vue';
import dayjs from 'dayjs';

const HEADER_HEIGHT = 150;
const VIEWPORT_THRESHOLD = 0.4;

export default {
  components: {
    EventItem,
    Placeholder,
    TrainingAnnouncements,
  },
  props: {
    monthEvents: {
      type: Array,
      default: () => [],
    },
    trainingAnnouncements: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getTrainingAnnouncementForMonth(monthName, year) {
      if (!this.trainingAnnouncements?.length) return null;

      const targetMonthStr = dayjs(`${monthName} ${year}`, 'MMMM YYYY').format('YYYY-MM');

      return this.trainingAnnouncements.find(announcement => {
        if (!announcement.month) return false;
        return dayjs(announcement.month).format('YYYY-MM') === targetMonthStr;
      });
    },
    findTopVisibleComponent() {
      const components = this.$el.querySelectorAll('.eventItem');
      let candidate = null;

      components.forEach(comp => {
        const rect = comp.getBoundingClientRect();
        const isVisible =
          rect.top <= window.innerHeight * VIEWPORT_THRESHOLD && rect.bottom >= HEADER_HEIGHT;
        if (isVisible && (!candidate || rect.top < candidate.rectTop)) {
          candidate = { element: comp, rectTop: rect.top };
        }
      });

      if (!candidate) {
        const first = components[0];
        if (!first) return null;
        return {
          month: first.getAttribute('month'),
          year: first.getAttribute('year'),
        };
      }

      return {
        month: candidate.element.getAttribute('month'),
        year: candidate.element.getAttribute('year'),
      };
    },
  },
};
</script>
